export enum EnrichmentStatus {
  QUEUED = 'queued',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
}

export enum EnrichmentType {
  PEOPLE = 'people',
  COMPANY = 'company',
}

export enum EnrichmentComponent {
  EMAIL = 'email',
  PHONE_EMAIL = 'emailphone',
}

export enum NewEnrichmentStep {
  SELECT_TYPE = 1,
  UPLOAD_MAP = 2,
  CHOOSE_COMPONENTS = 3,
}

export enum DateRangeFilter {
  SEVEN_DAYS = '7d',
  THIRTY_DAYS = '30d',
  NINETY_DAYS = '90d',
  ALL_TIME = 'all',
}

export const PEOPLE_EXPORT_COLUMNS = [
  'first_name',
  'last_name',
  'job_title',
  'department',
  'location_country',
  'location_state',
  'location_city',
  'company_name',
  'company_website',
  'company_industry',
  'company_size_range',
  'company_domain',
  'company_socials',
  'company_hq_country',
  'company_hq_state',
  'company_hq_city',
  'company_foundation_year',
  'company_is_b2b',
  'management_level',
  'linkedin_url',
  'emails',
  'past_companies',
  'tags',
  'socials',
  'skills',
  'education_degrees',
  'job_changed_on',
  'funding_date',
  'total_experience',
  'experience_at_current_company',
  'current_role_tenure_months',
  'projected_base_salary_dollars',
  'linkedin_followers_count',
  'company_annual_revenue',
  'company_founded_year',
  'decision_maker',
  'profile_summary',
] as const;

export const COMPANY_EXPORT_COLUMNS = [
  'company_name',
  'company_socials',
  'company_industry',
  'company_type',
  'company_is_b2b',
  'company_ownership_status',
  'company_description',
  'company_linkedin_followers_count',
  'competitors_companies',
  'funding_rounds',
  'sic_codes',
  'naics_codes',
  'categories_and_keywords',
  'technologies_used',
  'company_founded_year',
  'company_employee_count',
  'active_job_postings_count',
  'key_executive_departures',
  'key_executive_arrivals',
  'last_funding_round_amount_raised',
  'ebit',
  'ebitda',
  'ebitda_margin',
  'ebit_margin',
  'gross_profit',
  'gross_profit_margin',
  'net_income',
  'total_operating_expense',
  'cost_of_goods_sold',
  'total_website_visits_monthly',
  'visits_breakdown_by_country',
  'visits_breakdown_by_gender',
  'product_reviews_aggregate_score',
  'employee_reviews_aggregate_score',
  'employee_reviews_business_outlook',
  'employee_reviews_ceo_approval',
  'employee_reviews_career_opportunities',
  'employee_reviews_recommend',
  'employee_reviews_work_life_balance',
  'employee_reviews_culture_values',
] as const;
